import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, IconButton, Menu, MenuItem, Typography, Icon } from '@mui/material'


import Dialogs from './dialogs'

const MenuComponent = ({
  mode,
  user_name,
  telephony_profile_name,
  onSignOut,
  display_telephony,
  handleClick,
  handleClose,
  handleClickDarkMode,
  handleTelephony,
  onConfirmTelephonyPair,
  onOpenPasswordChangePopup,
  open,
  anchorEl,
  ...props }) =>
  <>
    <Dialogs {...props} />
    <IconButton onClick={handleClick} > <Icon sx={{ color: 'white' }}>account_circle</Icon> </IconButton>
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      sx={{ p: 0 }}
      PaperProps={{
        elevation: 6,
        sx: {
          overflow: 'visible',
          mt: 1.5,
          '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <MenuItem sx={{ pt: '11px', pb: '11px' }} divider disabled>
        <Icon sx={{ fontSize: 50 }}>account_circle</Icon>
        <Typography sx={{ ml: 3, fontSize: 'h6.fontSize' }}>
          {user_name}
        </Typography>
      </MenuItem>
      <MenuItem onClick={handleTelephony} sx={{ display: !!display_telephony ? 'flex' : 'none', pt: '11px', pb: '11px' }}>
        <Icon sx={{ mr: 1 }}>phone</Icon>
        <Box>
          <Typography >{I18n.t('telephony.label', { count: 1 })}</Typography>
          <Typography color='green'>{telephony_profile_name}</Typography>
        </Box>
      </MenuItem>
      <MenuItem sx={{ pt: '11px', pb: '11px' }} onClick={onOpenPasswordChangePopup}>
        <Icon sx={{ mr: 1 }}>edit</Icon>
        <Typography> {I18n.t('header.resetpassword')} </Typography>
      </MenuItem>
      <MenuItem sx={{ pt: '11px', pb: '11px' }} onClick={onSignOut}>
        <Icon sx={{ color: 'red', mr: 1 }}>power_settings_new</Icon>
        <Typography> {I18n.t('header.logout')} </Typography>
      </MenuItem>
      <MenuItem sx={{ pt: '11px', pb: '11px' }} onClick={handleClickDarkMode}>
        {mode !== 'dark' ? <Icon sx={{ color: 'moon', mr: 1 }}>brightness_3</Icon> : <Icon sx={{ color: 'sun', mr: 1 }}>wb_sunny</Icon>}
        <Typography sx={{ color: mode === 'dark' && 'sun' }}> {I18n.t(mode === 'dark' ? 'mode.active.light' : 'mode.active.dark')} </Typography>
      </MenuItem>
    </Menu>
  </>

export default React.memo(MenuComponent)
